import api from "./axiosInstance";

const getTrendingHashtags = (token, startDateStr, endDateStr, hexHash) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/hashtagsLatest`, {
        headers: {
           // Security Headers
          'X-XSS-Protection': '1; mode=block',
          Authorization: `Bearer ${token}`,
          'X-Content-Type-Options': 'nosniff',
          'X-Frame-Options': 'DENY',
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Permissions-Policy': 'camera=(), microphone=(), geolocation=()',
          
          // Standard Headers
          "Content-Type": "application/json",

        },
        params: {
          startDateStr: startDateStr,
          endDateStr: endDateStr,
          HPPcode: hexHash,
        },
      })
      .then((data, err) => {
        if (data) {
          //  
          resolve(data);
        } else {
          resolve("error");
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getTrendingHashtags;
